/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/molecules/rich-text/css/rich-text';
import '@swisslife/patterns-base/src/atoms/link/css/link';

import './immo-teaser-text-box.scss';
